import 'es6-promise/auto';
import 'babel-polyfill';
import Config from 'config';
let config;
import React from 'react';
import ReactDOM from 'react-dom';
import queryString from 'query-string';
import isFunction from 'lodash/isFunction';
import { redirectWithMessage, redirectWithError } from 'lib/common/fallbacks';

import AppContainer from 'containers/AppContainer';

function supportsSVG() {
  let div = document.createElement('div');
  div.innerHTML = '<svg/>';
  return (
    (typeof SVGRect != 'undefined' &&
      div.firstChild &&
      div.firstChild.namespaceURI) == 'http://www.w3.org/2000/svg'
  );
}

/**
 * SYOS contructor
 *
 * Requires an options parameter.
 * At the *miniumum*, the options parameter
 * must contain the Tessitura proxy endpoint.
 */
function SYOS(options) {
  if (!options.endpoint) {
    throw new Error('Endpoint not defined');
  }

  this.endpoint = options.endpoint;

  if (!isFunction(options.onComplete)) {
    throw new Error('on complete callback must be provided');
  }

  this.onComplete = options.onComplete;

  /**
   * Initial session key
   */
  this.initialSessionKey = options.initialSessionKey || undefined;

  /**
   * Initial performance number, facility number or package no.
   * If these aren't passed in via the constructor they can also
   * be passed via query string parameters.
   */
  this.initialPerfNo = options.initialPerfNo || undefined;
  this.initialFacilityNo = options.initialFacilityNo || undefined;
  this.initialPkgNo = options.initialPkgNo || undefined;

  /**
   * Initial MOS and source code (from LoginInfo)
   */
  this.initialMos = options.initialMos || undefined;
  this.initialPromoCode = options.initialPromoCode || undefined;
}
SYOS.prototype.run = function(rootEl) {
  let cutsMustard =
    supportsSVG() &&
    'querySelector' in document &&
    'addEventListener' in window &&
    'localStorage' in window &&
    'sessionStorage' in window &&
    'bind' in Function;

  /**
   * Check we are able to run SYOS
   * otherwise redirect to fallback URL
   */
  if (cutsMustard) {
    /**
     * Extract possible query parameters
     *
     * A valid URL contains *either* a performance number (perf_no) *OR* package number (pkg_no).
     *
     * `perf_no`
     * If the seat-map will show availability for a performance.
     * This is the default behaviour.
     *
     * `pkg_no`
     * If set the seat-map will show availability for a package.
     * This is used to allow editing of package level seats.
     *
     * `facility_no`
     * (Optional but recommended) Used to lookup a pre-drawn seat-map graphic.
     * Requires a seat-map graphic URL to have been provided for the current facility.
     * If no facility number is provided a basic seat-map will be generated
     *
     * Valid query strings:
     * ?perf_no=1234
     * ?perf_no=1234&facility_no=1
     * ?pkg_no=1234
     * ?pkg_no=1234&facility_no=1
     */
    let parsedQuery = queryString.parse(window.location.search);

    let initialPerformanceId = parsedQuery.perf_no
      ? parseInt(parsedQuery.perf_no, 10)
      : this.initialPerfNo;

    let packageNo = this.initialPkgNo;
    if (packageNo === undefined) {
      packageNo = parseInt(parsedQuery.pkg_no, 10);
    }

    let facilityNo = this.initialFacilityNo;
    if (facilityNo === undefined) {
      facilityNo = parseInt(parsedQuery.facility_no, 10);
    }

    if (!this.initialSessionKey && parsedQuery.session_key) {
      this.initialSessionKey = parsedQuery.session_key;
    }

    if (!this.initialPromoCode && parsedQuery.source_code) {
      this.initialPromoCode = parsedQuery.source_code;
    }

    if (!initialPerformanceId && !packageNo) {
      let err = Error('Performance number required (?perf_no=)');
      redirectWithError(err);
    }

    ReactDOM.render(
      <AppContainer
        endpoint={this.endpoint}
        onComplete={this.onComplete}
        initialSessionKey={this.initialSessionKey}
        initialPerformanceId={initialPerformanceId}
        initialMos={this.initialMos}
        initialPromoCode={this.initialPromoCode}
        packageNo={packageNo}
        facilityNo={facilityNo}
        queryParams={parsedQuery}
      />,
      rootEl
    );
  } else {
    config = new Config().getConfig();
    redirectWithMessage(config.fallbacks.unsupportedMessage);
  }
};

window.SYOS = SYOS;
export default SYOS;



// WEBPACK FOOTER //
// ./src/javascripts/main.js